<template>
    <div class="text-center text-info my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
    </div>
</template>

<script>
    export default {
        name: 'AcceptMarketplaces',
        data() {
            return {
                market: this.$route.params.pathMatch,
                query: Object.keys(this.$route.query).map(key => key + '=' + this.$route.query[key]).join('&')
            }
        },
        created() {
            this.selectMarket()
        },
        methods: {
            selectMarket() {
                let body = {}
                switch (this.market) {
                    case 'shopify':
                        body = {
                            query: this.query,
                            tokenData: localStorage.getItem('shopifyTokenData'),
                            shopName: localStorage.getItem('shopifyShopName'),
                        }
                        this.acceptMarket({body, url: this.$endpoints.market(this.market)}).then(() => {
                            localStorage.removeItem('shopifyTokenData')
                            localStorage.removeItem('shopifyShopName')
                            this.redirectUser()
                        })
                        break
                    case 'ebay':
                        body = {
                            tokenData: localStorage.getItem('ebayTokenData'),
                            username: this.$route.query.username
                        }
                        let regionCode = '/' + localStorage.getItem('ebayRegionCode')
                        this.acceptMarket({body, url: this.$endpoints.market(this.market) + regionCode})
                            .then(() => {
                                localStorage.removeItem('ebayTokenData')
                                localStorage.removeItem('ebayRegionCode')
                                this.redirectUser()
                            })
                        break
                    case 'etsy':
                        body = {
                            query: this.query,
                            tokenData: localStorage.getItem('etsyTokenData'),
                            verificationCode: localStorage.getItem('etsyVerificationCode'),
                        }
                        this.acceptMarket({body, url: this.$endpoints.market(this.market)}).then(() => {
                            localStorage.removeItem('etsyTokenData')
                            localStorage.removeItem('etsyVerificationCode')
                            this.redirectUser()
                        })
                        break
                }
            },
            acceptMarket(payload) {
                return this.$api('PUT', payload.url, payload.body)
                    .then(() => this.$store.dispatch('globalAlertAction', {
                        type: 'success',
                        title: 'Congratulations! The integration was done successfully!',
                        message: 'Please notice, that it may take some time before the integrated products will be shown in the List of integrated products!',
                        timeout: 15000
                    }))
                    .catch(error => error)
            },
            redirectUser() {
                this.$router.push({name: 'Marketplaces', params: {market: this.market}})
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/UserSettings/Marketplaces/AcceptMarketplaces.vue